/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AtlasProject } from '../models/AtlasProject';

export class AtlasProjects {
  'projects': Array<AtlasProject>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "projects",
      "baseName": "projects",
      "type": "Array<AtlasProject>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AtlasProjects.attributeTypeMap;
  }

  public constructor() {
  }
}

